import { useSetRecoilState } from 'recoil'

import { lightboxVideoModalState } from 'src/atoms/ui.atom'
import {
  ItListItemAnalyticsProps,
  useAnalytics,
} from 'src/lib/hooks/analytics/useAnalytics'
import { matchUrl } from 'src/lib/utils'
import { openLinkInNewTab } from 'src/lib/utils'
import { BrandColor } from 'src/types'

export default function useContentCard(
  brandColor: BrandColor,
  trackingData: ItListItemAnalyticsProps,
  url?: string
) {
  const { track } = useAnalytics()
  const setVideoModal = useSetRecoilState(lightboxVideoModalState)

  const onClick = (ev: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    ev.stopPropagation()
    ev.preventDefault()
    track({ eventName: 'ItList Content Item Clicked', props: trackingData })
    if (!url) return
    const isYoutube =
      ['youtube.com', 'youtu.be'].some((p) => matchUrl(p, url)) &&
      isRootPath(url) // prevent to try to render /channels/ in youtube urls
    const isVimeo = matchUrl('vimeo.com', url)
    if (isVimeo) {
      setVideoModal({ vimeoUrl: url, brandColor })
    } else if (isYoutube) {
      setVideoModal({ youtubeUrl: url, brandColor })
    } else {
      openLinkInNewTab(url)
    }
  }
  return { onClick }
}

function isRootPath(url: string): boolean {
  const urlObject = new URL(url)
  return !urlObject.pathname.substring(1).includes('/')
}
